import { getLocalStorage, removeLocalStorage, setLocalStorage } from 'common/utils/localstorage';
import { toQueryString } from 'common/utils/urlUtils';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const LOGIN_WATCH_INTERVAL = 1000;

const getWindowProperty = (window, propertyName) => {
  try {
    return window[propertyName] ?? false;
  } catch (err) {
    console.log(`caught error${err}`);
  }

  return false;
};

export const getLoginWindow = (URL, width = 1220, height = 770) => {
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  return window.open(
    URL,
    'newWindow',
    `height=${height},width=${width},top=${top},left=${left},scrollbars=yes,status=yes,modal=yes,alwaysRaised=yes`
  );
};

export const initiateUserAuth = (values = {}) => {
  const queryParams = { origin: 'pop_up_window' };
  if (values.action) queryParams.action = values.action;
  if (values.plan) queryParams.plan = values.plan;
  if (values.login_label) queryParams.login_label = values.login_label;

  const getUrlConfig = () => {
    switch (true) {
      case ApplicationDomainUtility.isAlgoverse:
        return { url: `/auth/upstox`, openInSamePage: true };
      default: {
        if (queryParams.action === 'plan_purchase') {
          setLocalStorage('from_payment_login', 'true');
        }
        return { url: `/popup_login?${toQueryString(queryParams)}`, openInSamePage: false };
      }
    }
  };

  const { url, openInSamePage } = getUrlConfig();

  // For Algoverse, redirect in the same page to avoid cross-domain child window issues
  if (openInSamePage) {
    window.location.href = url;
    // Return a never-resolving promise to prevent .then() from overriding the navigation
    return new Promise(() => { });
  }

  // For other domains, use child window as default
  const loginWindow = getLoginWindow(url);

  return new Promise((resolve, reject) => {
    const loginWatch = setInterval(async () => {
      if (getWindowProperty(loginWindow, 'closed') || getWindowProperty(loginWindow, 'complete')) {
        clearInterval(loginWatch);
        await fetch('/clear_auth_window_session');

        if ((getWindowProperty(loginWindow, 'complete') && getWindowProperty(loginWindow, 'loginSuccess'))
          || getWindowProperty(loginWindow, 'allowBacktestPlanPurchase')) {
          const isPlanLogin = getLocalStorage('from_payment_login') === 'true';
          if (isPlanLogin) {
            removeLocalStorage('from_payment_login');
            return resolve({ href: `${window.location.origin}/plans` });
          }
          return resolve(loginWindow.location);
        }

        reject();
      }
    }, LOGIN_WATCH_INTERVAL);
  });
};

window.initiateUserAuth = initiateUserAuth;

export const initiateBrokerCallbackLogin = async (selectedBrokerHref, isGoogle = false) => {
  // this is to identify the ONLY broker auth window [not user_auth window]
  // with this we can show a redirecting page while the broker auth is in progress
  // TODO: improve this with a better approach, This is dividing the broker login into 2 pieces
  const shouldSkipCookieSet = ['/popup_login'].includes(window.location.pathname);
  if (!shouldSkipCookieSet) {
    document.cookie = `is_broker_auth_window=true; path=/;`;
  };

  const loginWindow = isGoogle
    ? getLoginWindow('/auth/google_oauth2', 400, 600)
    : getLoginWindow(selectedBrokerHref);

  return new Promise((resolve, reject) => {
    const loginWatch = setInterval(async () => {
      try {
        if (getWindowProperty(loginWindow, 'closed')
          || getWindowProperty(loginWindow, 'complete')
          || getWindowProperty(loginWindow, 'isUserSignedIn')
        ) {
          clearInterval(loginWatch);
          // This below html [clear_auth_window_session action] will close the child window
          await fetch('/clear_auth_window_session');

          if (getWindowProperty(loginWindow, 'isUserSignedIn')) {
            const isPlanLogin = getLocalStorage('from_payment_login') === 'true';
            if (isPlanLogin) {
              removeLocalStorage('from_payment_login');
              return resolve({ href: `${window.location.origin}/plans` });
            }
            return resolve(loginWindow.location);
          }
          reject();
        }
      } catch (error) {
        document.cookie = `is_broker_auth_window=false; path=/;`;
        reject(error);
      }
    }, LOGIN_WATCH_INTERVAL);
  });
};

